<template>
  <div id="app" class="min-h-screen bg-gray-900">
    <!-- Navigation -->
    <nav class="fixed top-0 w-full z-50 bg-gray-900/95 backdrop-blur-sm border-b border-gray-800">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-16">
          <!-- Logo -->
          <div class="flex items-center">
            <XCarsLogo :width="160" :height="48" />
          </div>
          
          <!-- Navigation Links -->
          <div class="hidden md:flex items-center space-x-8">
            <a href="#home" class="nav-link">Home</a>
            <a href="#mint" class="nav-link">Mint</a>
            <!-- <a href="#roadmap" class="nav-link">Roadmap</a>
            <a href="#team" class="nav-link">Team</a> -->
          </div>
          
          <!-- Wallet Connect -->
          <div class="w-48">
            <WalletConnect />
          </div>
        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="pt-16">
      <!-- Hero Section -->
      <section id="home">
        <HeroSection />
      </section>

      <!-- Mint Section -->
      <section id="mint" class="py-20 bg-gray-800">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-12">
            <h2 class="text-4xl font-bold text-white mb-4">Mint Your X CARS NFT</h2>
            <p class="text-xl text-gray-300 max-w-3xl mx-auto">
              Join the exclusive community of X CARS collectors. Each NFT is a unique piece of digital art 
              representing the future of automotive culture on the blockchain.
            </p>
          </div>
          
          <div class="flex justify-center">
            <NFTMint />
          </div>
        </div>
      </section>

      <!-- X CARS Collection Showcase -->
      <section id="collection" class="py-20 bg-gray-900">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-16">
            <h2 class="text-4xl font-bold text-white mb-4">X CARS Collection</h2>
            <p class="text-xl text-gray-300 max-w-3xl mx-auto">
              Explore the stunning pixel art world of X CARS. Each NFT represents a unique combination 
              of classic vehicles and atmospheric landscapes, crafted with meticulous attention to detail.
            </p>
          </div>
          
          <!-- Featured Collection Image -->
          <div class="flex justify-center mb-12">
            <div class="featured-image-container">
              <div class="image-frame">
                <img 
                  src="/img/1.png" 
                  alt="X CARS Collection - Featured Artwork"
                  class="featured-image"
                />
              </div>
              <div class="image-glow"></div>
            </div>
          </div>
          
          <!-- Collection Stats -->
          <div class="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
            <div class="stat-card">
              <div class="stat-number">10,000</div>
              <div class="stat-label">Total Supply</div>
            </div>
            <div class="stat-card">
              <div class="stat-number">100+</div>
              <div class="stat-label">Unique Traits</div>
            </div>
            <div class="stat-card">
              <div class="stat-number">50+</div>
              <div class="stat-label">Vehicle Models</div>
            </div>
            <div class="stat-card">
              <div class="stat-number">20+</div>
              <div class="stat-label">Landscapes</div>
            </div>
          </div>
          
          <!-- Call to Action -->
          <div class="text-center">
            <p class="text-gray-400 text-lg mb-6">
              Your first dream NFT on X Layer
            </p>
            <a 
              href="#mint" 
              class="inline-block bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-bold py-4 px-10 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-purple-500/25"
            >
              Start Minting Now
            </a>
          </div>
        </div>
      </section>

      <!-- Features Section -->
      <!-- <section class="py-20 bg-gray-800">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-12">
            <h2 class="text-4xl font-bold text-white mb-4">Why X CARS?</h2>
          </div>
          
          <div class="grid md:grid-cols-3 gap-8">
            <div class="feature-card">
              <div class="feature-icon">🎨</div>
              <h3 class="feature-title">High-Quality Art</h3>
              <p class="feature-description">
                Each NFT is meticulously crafted with pixel-perfect detail, 
                showcasing unique automotive designs and atmospheric landscapes.
              </p>
            </div>
            
            <div class="feature-card">
              <div class="feature-icon">🌐</div>
              <h3 class="feature-title">X Layer Native</h3>
              <p class="feature-description">
                Built specifically for X Layer blockchain, ensuring fast transactions, 
                low fees, and seamless integration with the ecosystem.
              </p>
            </div>
            
            <div class="feature-card">
              <div class="feature-icon">👥</div>
              <h3 class="feature-title">Community Driven</h3>
              <p class="feature-description">
                Join a passionate community of collectors and automotive enthusiasts. 
                Shape the future of the project through governance and collaboration.
              </p>
            </div>
          </div>
        </div>
      </section> -->
    </main>

    <!-- Footer -->
    <footer class="bg-gray-900 border-t border-gray-800 py-12">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid md:grid-cols-4 gap-8">
          <div class="col-span-2">
            <XCarsLogo :width="200" :height="60" />
            <p class="text-gray-400 mt-4 max-w-md">
              X Layer's first high-quality 10k original NFT collection. 
              Your first dream NFT on X Layer.
            </p>
          </div>
          
          <div>
            <h4 class="text-white font-semibold mb-4">Links</h4>
            <div class="space-y-2">
              <!-- <a href="#" class="footer-link">OpenSea</a> -->
              <a href="#" class="footer-link">Discord</a>
              <a href="#" class="footer-link">Twitter</a>
              <a href="#" class="footer-link">Medium</a>
            </div>
          </div>
          
          <div>
            <h4 class="text-white font-semibold mb-4">Resources</h4>
            <div class="space-y-2">
              <!-- <a href="#" class="footer-link">Whitepaper</a>
              <a href="#" class="footer-link">Roadmap</a>
              <a href="#" class="footer-link">FAQ</a> -->
              <a href="#" class="footer-link">Support</a>
            </div>
          </div>
        </div>
        
        <div class="border-t border-gray-800 mt-8 pt-8 text-center">
          <p class="text-gray-400">
            © 2024 X CARS. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import XCarsLogo from '@/components/XCarsLogo.vue'
import WalletConnect from '@/components/WalletConnect.vue'
import HeroSection from '@/components/HeroSection.vue'
import NFTMint from '@/components/NFTMint.vue'

// Removed collection preview data as we're now using promotional images
</script>

<style scoped>
.nav-link {
  @apply text-gray-300 hover:text-white transition-colors duration-200 font-medium;
}

.featured-image-container {
  @apply relative max-w-4xl mx-auto;
}

.image-frame {
  @apply relative z-10 rounded-2xl overflow-hidden shadow-2xl border-4 border-gray-700 transform hover:scale-105 transition-all duration-500;
}

.featured-image {
  @apply w-full h-auto object-cover;
}

.image-glow {
  @apply absolute inset-0 bg-gradient-to-r from-purple-600/20 to-pink-600/20 rounded-2xl blur-xl -z-10 scale-110;
}

.stat-card {
  @apply bg-gray-800 rounded-xl p-6 text-center border border-gray-700 hover:border-purple-500 transition-colors duration-300;
}

.stat-number {
  @apply text-3xl font-bold text-white mb-2;
}

.stat-label {
  @apply text-gray-400 text-sm uppercase tracking-wide;
}

.feature-card {
  @apply bg-gray-900 rounded-xl p-8 text-center space-y-4 border border-gray-700 hover:border-purple-500 transition-colors duration-300;
}

.feature-icon {
  @apply text-5xl mx-auto;
}

.feature-title {
  @apply text-xl font-bold text-white;
}

.feature-description {
  @apply text-gray-300 leading-relaxed;
}

.footer-link {
  @apply block text-gray-400 hover:text-white transition-colors duration-200;
}
</style>